// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetListCellView-modulebuttons__HKIJ9";
var _2 = "ProfileContactsWidgetListCellView-modulecontent__xMal2";
var _3 = "ProfileContactsWidgetListCellView-modulelabel__mWNoG";
var _4 = "ProfileContactsWidgetListCellView-modulelink__la8wb";
var _5 = "ProfileContactsWidgetListCellView-modulenoValueText__A8XVd";
var _6 = "ProfileContactsWidgetListCellView-modulerow__rdeCK";
var _7 = "ProfileContactsWidgetListCellView-moduletext__sFiTZ";
var _8 = "ProfileContactsWidgetListCellView-moduletextButton__vr3xT";
export { _1 as "buttons", _2 as "content", _3 as "label", _4 as "link", _5 as "noValueText", _6 as "row", _7 as "text", _8 as "textButton" }
